var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMoveDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dq1al1lsna",
    d: "M7.505 2.707c.121 0 .22.098.22.22v7.968c0 .121.098.22.22.22H9.45c.06 0 .118.024.16.068.083.088.08.227-.008.31l-2.484 2.363c-.085.08-.218.08-.303 0l-2.484-2.363c-.044-.041-.068-.099-.068-.159 0-.121.098-.22.22-.22h1.505c.122 0 .22-.098.22-.22V2.927c0-.121.098-.22.22-.22zM2.882.144c.085-.08.218-.08.303 0l2.484 2.363c.044.041.068.099.068.159 0 .121-.098.22-.22.22H4.013c-.122 0-.22.098-.22.22v7.968c0 .121-.098.22-.22.22H2.496c-.121 0-.22-.099-.22-.22V3.105c0-.121-.098-.22-.22-.22H.55c-.06 0-.118-.024-.16-.068-.083-.088-.08-.227.008-.31z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-28 -530) translate(11 105) translate(0 315) translate(10 99) translate(0 6) translate(7 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "13wckwzrob",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dq1al1lsna"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    xlinkHref: "#dq1al1lsna"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#282828",
    mask: "url(#13wckwzrob)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H29.333V28H0z",
    transform: "translate(-10 -7)"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoveDrag);
export default __webpack_public_path__ + "static/media/icon-move-drag.6770b7b8c86fdcfef887bc34a22e8a05.svg";
export { ForwardRef as ReactComponent };